import { Directive, ElementRef, Renderer2, effect, HostListener } from '@angular/core';
import { ButtonLoadingService } from './button-loading.service';

/**
 * Blocks interaction while global HTTP loading is active.
 * Does not set/remove the native `disabled` attribute - that would override Angular
 * bindings like `[disabled]="form.invalid"` when loading ends.
 */
@Directive({
    selector: '[appDisableWhileLoading]',
    standalone: true
})
export class DisableWhileLoadingDirective {
    constructor(
        private el: ElementRef<HTMLElement>,
        private renderer: Renderer2,
        private loadingService: ButtonLoadingService
    ) {
        effect(() => {
            const isLoading = this.loadingService.loading();
            if (isLoading) {
                this.renderer.setStyle(this.el.nativeElement, 'pointer-events', 'none');
                this.renderer.setStyle(this.el.nativeElement, 'opacity', '0.6');
                this.renderer.setAttribute(this.el.nativeElement, 'aria-busy', 'true');
            } else {
                this.renderer.removeStyle(this.el.nativeElement, 'pointer-events');
                this.renderer.removeStyle(this.el.nativeElement, 'opacity');
                this.renderer.removeAttribute(this.el.nativeElement, 'aria-busy');
            }
        });
    }

    @HostListener('click', ['$event'])
    onClick(event: Event): void {
        if (this.loadingService.loading()) {
            event.preventDefault();
            event.stopImmediatePropagation();
        }
    }

    @HostListener('keydown', ['$event'])
    onKeydown(event: KeyboardEvent): void {
        if (!this.loadingService.loading()) {
            return;
        }
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            event.stopImmediatePropagation();
        }
    }
}
